export const isMobile = (): boolean => {
  return matchMedia('(max-width: 768px)').matches
}

export const checkAnimationReduce = (): boolean => {
  return matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const isTouch = (): boolean => {
  return matchMedia('(hover: none) and (pointer:coarse)').matches
}
